// helper types

// Looser typing of https://github.com/HubSpotEngineering/crm-events-viz/blob/master/crm-events-viz-core/static/js/types/TimelineEvent.ts#L14
// TODO: Ensure strict typing after the rollout of CRM:Events:EngagementDetailMigration
const HUBSPOT_DEFINED = 'HUBSPOT_DEFINED';
const USER_DEFINED = 'USER_DEFINED';
const INTEGRATOR_DEFINED = 'INTEGRATOR_DEFINED';

// Copied from crm-cards-sdk/static/js/types.ts to avoid circular dependency

// eslint-disable-next-line @typescript-eslint/no-empty-interface

export const TOPIC_NAMES = {
  sample: 'sample',
  sample2: 'sample2',
  ADD_ENGAGEMENT: 'ADD_ENGAGEMENT',
  CONTAINER_TAB_OPENED: 'CONTAINER_TAB_OPENED',
  DISPATCHED_EVENT: 'DISPATCHED_EVENT',
  UPDATE_ASSOCIATIONS: 'UPDATE_ASSOCIATIONS',
  OBJECT_CREATED: 'OBJECT_CREATED',
  OBJECT_DELETED: 'OBJECT_DELETED',
  OBJECTS_DELETED: 'OBJECTS_DELETED',
  UPDATE_OBJECT: 'UPDATE_OBJECT',
  UPDATE_OBJECTS: 'UPDATE_OBJECTS',
  PREVIEW_OBJECT: 'PREVIEW_OBJECT',
  OPEN_UNIVERSAL_RECORD: 'OPEN_UNIVERSAL_RECORD',
  UNIVERSAL_RECORD_CLOSED: 'UNIVERSAL_RECORD_CLOSED',
  CLOSE_UNIVERSAL_RECORD: 'CLOSE_UNIVERSAL_RECORD',
  PREVIEW_ENGAGEMENT: 'PREVIEW_ENGAGEMENT',
  CLOSE_PREVIEW_OBJECT: 'CLOSE_PREVIEW_OBJECT',
  OPEN_ACTIVITY_CREATOR: 'OPEN_ACTIVITY_CREATOR',
  CLOSE_ACTIVITY_CREATOR: 'CLOSE_ACTIVITY_CREATOR',
  ACTIVITY_CREATOR_OPENED: 'ACTIVITY_CREATOR_OPENED',
  ACTIVITY_CREATOR_CLOSED: 'ACTIVITY_CREATOR_CLOSED',
  OPEN_ACTIVITY_QUICK_VIEW_MODAL: 'OPEN_ACTIVITY_QUICK_VIEW_MODAL',
  OPEN_CALL_WIDGET: 'OPEN_CALL_WIDGET',
  OPEN_OBJECT_BUILDER: 'OPEN_OBJECT_BUILDER',
  OPEN_UPDATE_ASSOCIATION_MODAL: 'OPEN_UPDATE_ASSOCIATION_MODAL',
  OPEN_IFRAME_MODAL: 'OPEN_IFRAME_MODAL',
  IFRAME_MODAL_CLOSED: 'IFRAME_MODAL_CLOSED',
  SHOW_ALERT: 'SHOW_ALERT',
  OPEN_PLAYBOOK: 'OPEN_PLAYBOOK',
  SEQUENCE_ENROLLMENT: 'SEQUENCE_ENROLLMENT',
  SEQUENCE_UNENROLL: 'SEQUENCE_UNENROLL',
  COMMENTS_UPDATED: 'COMMENTS_UPDATED',
  PINNED_ENGAGEMENT_UPDATED: 'PINNED_ENGAGEMENT_UPDATED',
  INTERNAL_REGISTER_COMMAND_SUBSCRIBED: 'INTERNAL_REGISTER_COMMAND_SUBSCRIBED',
  INTERNAL_REGISTER_COMMAND_UNSUBSCRIBED: 'INTERNAL_REGISTER_COMMAND_UNSUBSCRIBED',
  OPEN_PROPERTY_HISTORY: 'OPEN_PROPERTY_HISTORY',
  OPEN_ENRICHMENT_PROPERTIES_PANEL: 'OPEN_ENRICHMENT_PROPERTIES_PANEL',
  CLOSE_ENRICHMENT_PROPERTIES_PANEL: 'CLOSE_ENRICHMENT_PROPERTIES_PANEL',
  OPEN_SMART_PROPERTIES_PANEL: 'OPEN_SMART_PROPERTIES_PANEL',
  CLOSE_SMART_PROPERTIES_PANEL: 'CLOSE_SMART_PROPERTIES_PANEL',
  POLL_SMART_PROPERTIES: 'POLL_SMART_PROPERTIES',
  OPEN_CARD_USER_CUSTOMIZATION: 'OPEN_CARD_USER_CUSTOMIZATION',
  OPEN_DEAL_SCORE_HISTORY: 'OPEN_DEAL_SCORE_HISTORY',
  UPDATE_CARD_CONFIGURATION: 'UPDATE_CARD_CONFIGURATION',
  OPEN_COLLAB_SIDEBAR: 'OPEN_COLLAB_SIDEBAR',
  UPDATE_APPROVAL_CARD: 'UPDATE_APPROVAL_CARD',
  UPDATE_RECORD_ATTACHMENTS: 'UPDATE_RECORD_ATTACHMENTS',
  OPEN_ATTACHMENTS_MODAL: 'OPEN_ATTACHMENTS_MODAL',
  OPEN_ATTACHMENTS_FILE_MANAGER: 'OPEN_ATTACHMENTS_FILE_MANAGER',
  OPEN_ATTACHMENTS_REMOVE_MODAL: 'OPEN_ATTACHMENTS_REMOVE_MODAL',
  RECORD_ATTACHMENTS_REMOVED: 'RECORD_ATTACHMENTS_REMOVED',
  OPEN_MANAGE_RECORD_ACCESS_PANEL: 'OPEN_MANAGE_RECORD_ACCESS_PANEL',
  OPEN_SHARE_ENGAGEMENT_ACCESS_MODAL: 'OPEN_SHARE_ENGAGEMENT_ACCESS_MODAL',
  OPEN_ACTIVITY_TIMELINE_SIDEBAR: 'OPEN_ACTIVITY_TIMELINE_SIDEBAR',
  CLOSE_ACTIVITY_TIMELINE_SIDEBAR: 'CLOSE_ACTIVITY_TIMELINE_SIDEBAR',
  OPEN_DEAL_SPLITS_SIDEBAR: 'OPEN_DEAL_SPLITS_SIDEBAR',
  OPEN_DEAL_SPLITS_DELETE_MODAL: 'OPEN_DEAL_SPLITS_DELETE_MODAL',
  DEAL_SPLIT_DELETED: 'DEAL_SPLIT_DELETED',
  OPEN_SCORE_HISTORY: 'OPEN_SCORE_HISTORY',
  OPEN_RECENT_PRODUCTS: 'OPEN_RECENT_PRODUCTS',
  OPEN_DEAL_REGISTRATION_SUMMARY: 'OPEN_DEAL_REGISTRATION_SUMMARY',
  CLOSE_DEAL_REGISTRATION_SUMMARY: 'CLOSE_DEAL_REGISTRATION_SUMMARY',
  OPEN_WORKFLOW_ENROLLMENT_MODAL: 'OPEN_WORKFLOW_ENROLLMENT_MODAL',
  UPDATE_WORKFLOW_ENROLLMENTS: 'UPDATE_WORKFLOW_ENROLLMENTS',
  OPEN_MULTI_ACCOUNT_PANEL: 'OPEN_MULTI_ACCOUNT_PANEL',
  OPEN_PORTAL_USERS_PANEL: 'OPEN_PORTAL_USERS_PANEL',
  OPEN_DELETE_ENGAGEMENT_MODAL: 'OPEN_DELETE_ENGAGEMENT_MODAL',
  OPEN_DELETE_SCHEDULED_EMAIL_MODAL: 'OPEN_DELETE_SCHEDULED_EMAIL_MODAL',
  OPEN_DELETE_DRAFT_EMAIL_MODAL: 'OPEN_DELETE_DRAFT_EMAIL_MODAL',
  OPEN_DELETE_TASK_MODAL: 'OPEN_DELETE_TASK_MODAL',
  OPEN_REPLACE_PINNED_ENGAGEMENT_MODAL: 'OPEN_REPLACE_PINNED_ENGAGEMENT_MODAL',
  OPEN_MERGE_OBJECTS_MODAL: 'OPEN_MERGE_OBJECTS_MODAL',
  OPEN_UNMERGE_OBJECTS_MODAL: 'OPEN_UNMERGE_OBJECTS_MODAL',
  OPEN_CLONE_OBJECTS_MODAL: 'OPEN_CLONE_OBJECTS_MODAL',
  OPEN_REVIEW_ASSOCIATIONS_MODAL: 'OPEN_REVIEW_ASSOCIATIONS_MODAL',
  COMMAND_HANDLER_PING: 'COMMAND_HANDLER_PING',
  COMMAND_HANDLER_PONG: 'COMMAND_HANDLER_PONG',
  OPEN_SEQUENCE_ENROLLMENT_MODAL: 'OPEN_SEQUENCE_ENROLLMENT_MODAL',
  OPEN_HIDE_EMAIL_TRACKING_MODAL: 'OPEN_HIDE_EMAIL_TRACKING_MODAL',
  PROPERTY_DEFINITIONS_UPDATED: 'PROPERTY_DEFINITIONS_UPDATED',
  INDEX_VIEW_CREATED: 'INDEX_VIEW_CREATED',
  OPEN_ALL_PROPERTIES_PANEL: 'OPEN_ALL_PROPERTIES_PANEL',
  OPEN_ASSOCIATION_HISTORY_PANEL: 'OPEN_ASSOCIATION_HISTORY_PANEL',
  OPEN_INFLUENCED_CAMPAIGNS_PANEL: 'OPEN_INFLUENCED_CAMPAIGNS_PANEL',
  OPEN_EDIT_CAMPAIGN_ENGAGEMENT_MODAL: 'OPEN_EDIT_CAMPAIGN_ENGAGEMENT_MODAL',
  OPEN_EDIT_CAMPAIGN_MARKETING_EVENT_MODAL: 'OPEN_EDIT_CAMPAIGN_MARKETING_EVENT_MODAL',
  CREATE_COLUMN_INSIGHTS: 'CREATE_COLUMN_INSIGHTS',
  OPEN_CONTRACT_TERMINATE_MODAL: 'OPEN_CONTRACT_TERMINATE_MODAL',
  OPEN_CONTRACT_MANAGE_TERMINATION_MODAL: 'OPEN_CONTRACT_MANAGE_TERMINATION_MODAL',
  OPEN_CONTRACT_CANCEL_TERMINATION_MODAL: 'OPEN_CONTRACT_CANCEL_TERMINATION_MODAL',
  OPEN_CONTRACT_CHANGE_QUOTE_MODAL: 'OPEN_CONTRACT_CHANGE_QUOTE_MODAL',
  OPEN_CONTRACT_CANCEL_CHANGE_QUOTE_MODAL: 'OPEN_CONTRACT_CANCEL_CHANGE_QUOTE_MODAL',
  OPEN_CONTRACT_UPDATE_PAYMENT_METHOD_MODAL: 'OPEN_CONTRACT_UPDATE_PAYMENT_METHOD_MODAL',
  OPEN_CONTRACT_RENEWAL_QUOTE_MODAL: 'OPEN_CONTRACT_RENEWAL_QUOTE_MODAL',
  OPEN_CONTRACT_CANCEL_RENEWAL_QUOTE_MODAL: 'OPEN_CONTRACT_CANCEL_RENEWAL_QUOTE_MODAL',
  OPEN_CONTRACT_DELETE_MODAL: 'OPEN_CONTRACT_DELETE_MODAL',
  OPEN_INVOICE_MODAL: 'OPEN_INVOICE_MODAL',
  OPEN_INVOICE_ACTION_MODAL: 'OPEN_INVOICE_ACTION_MODAL',
  OPEN_INVOICE_SEND_EMAIL_MODAL: 'OPEN_INVOICE_SEND_EMAIL_MODAL',
  OPEN_CREDIT_MEMO_MODAL: 'OPEN_CREDIT_MEMO_MODAL',
  OPEN_EXISTING_SEQUENCE_ENROLLMENT_MODAL: 'OPEN_EXISTING_SEQUENCE_ENROLLMENT_MODAL',
  OPEN_SEQUENCE_UNENROLL_MODAL: 'OPEN_SEQUENCE_UNENROLL_MODAL',
  OPEN_BILLING_WIZARD_MODAL: 'OPEN_BILLING_WIZARD_MODAL',
  OPEN_SUBSCRIPTIONS_ADMIN_MODAL: 'OPEN_SUBSCRIPTIONS_ADMIN_MODAL',
  OPEN_PROSPECTING_AGENT_MODAL: 'OPEN_PROSPECTING_AGENT_MODAL',
  OPEN_ROUTING_ASSIGNMENT_DETAILS_PANEL: 'OPEN_ROUTING_ASSIGNMENT_DETAILS_PANEL',
  PROSPECTING_AGENT_ENROLLMENT: 'PROSPECTING_AGENT_ENROLLMENT',
  PROSPECTING_AGENT_UNENROLLMENT: 'PROSPECTING_AGENT_UNENROLLMENT',
  OPEN_CALL_TRANSCRIPT_SIDEBAR: 'OPEN_CALL_TRANSCRIPT_SIDEBAR',
  CLOSE_CALL_TRANSCRIPT_SIDEBAR: 'CLOSE_CALL_TRANSCRIPT_SIDEBAR',
  GOOGLE_DRIVE_INTEGRATION: 'GOOGLE_DRIVE_INTEGRATION',
  OPEN_SMART_DATA_CAPTURE_MODAL: 'OPEN_SMART_DATA_CAPTURE_MODAL',
  UPDATE_SMART_DATA_PROPERTY_SUGGESTIONS: 'UPDATE_SMART_DATA_PROPERTY_SUGGESTIONS',
  CARD_CONFIG_CHANGED: 'CARD_CONFIG_CHANGED',
  CLOSE_PREVIEW_ENGAGEMENT: 'CLOSE_PREVIEW_ENGAGEMENT',
  OPEN_BUYING_GROUP_CANVAS_MODAL: 'OPEN_BUYING_GROUP_CANVAS_MODAL',
  BUYING_GROUP_CANVAS_MODAL_CLOSED: 'BUYING_GROUP_CANVAS_MODAL_CLOSED',
  OPEN_IMPORT_CONTACTS_MODAL: 'OPEN_IMPORT_CONTACTS_MODAL',
  OPEN_ADD_POI_MODAL: 'OPEN_ADD_POI_MODAL',
  OPEN_SALES_ORDER_WIZARD: 'OPEN_SALES_ORDER_WIZARD',
  VIEW_UPDATE_REQUESTED: 'VIEW_UPDATE_REQUESTED',
  VIEW_UPDATE_COMPLETED: 'VIEW_UPDATE_COMPLETED'
};